import {CentrifugeCompaniesReportNotifications} from '../../page/main/my-companies/companies-report/companies-report-notification/companies-report-notification';

import {CentrifugeDeployNotifications} from './deploy/centrifuge-deploy-notifications';

type PropsType = {
    onDeployActionReceived: VoidFunction;
};

export function CentrifugeListenersAuthorized(props: PropsType): JSX.Element {
    const {onDeployActionReceived} = props;

    return (
        <>
            <CentrifugeDeployNotifications onDeployActionReceived={onDeployActionReceived} />
            <CentrifugeCompaniesReportNotifications />
        </>
    );
}
